/* unplugin-vue-components disabled */import { render } from "./examOnlineMain.vue?vue&type=template&id=325e12a6&scoped=true&ts=true"
import script from "./examOnlineMain.vue?vue&type=script&lang=ts"
export * from "./examOnlineMain.vue?vue&type=script&lang=ts"

import "./examOnlineMain.vue?vue&type=style&index=0&id=325e12a6&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325e12a6"]])

export default __exports__